<template>
  <div class="edit">
    <user-info :userInfo="userInfo" :isShowFansBar="false" />
    <div class="content-bg">
      <!-- <h3>完善个人资料得140积分</h3> -->
      <van-form @submit="onSubmit">
        <van-field v-model="userInfo.nickname" label="修改昵称" />
        <van-field label="修改头像">
          <template #input>
            <van-uploader
              v-model="fileList"
              :after-read="afterRead"
              :max-count="1"
              :before-delete="beforeDelete"
            >
              <van-button
                icon="plus"
                type="default"
                size="small"
                color="#D33A46"
                >上传头像</van-button
              >
            </van-uploader>
          </template>
        </van-field>
        <van-field v-model="userInfo.name" label="真实姓名" required />
        <van-field label="性别" required>
          <template #input>
            <van-radio-group
              v-model="userInfo.gender"
              direction="horizontal"
              checked-color="#D33A46"
            >
              <van-radio :name="1">男</van-radio>
              <van-radio :name="2">女</van-radio>
              <van-radio :name="0">其他</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="userInfo.phone"
          label="手机号码"
          type="tel"
          required
          :error-message="errorPhone"
          @blur="phoneBlur"
          @input="changePhone"
        />
        <van-field
          v-show="isChangePhone"
          v-model="verification_code"
          required
          label="验证码"
          type="number"
        >
          <template #button>
            <van-button
              v-if="codeShow"
              size="small"
              color="#D33A46"
              @click.stop="sendCodeClick"
              >获取验证码</van-button
            >
            <van-button v-if="!codeShow" size="small" disabled
              >{{ count }}秒后重试</van-button
            >
          </template>
        </van-field>

        <van-field
          readonly
          clickable
          :value="value"
          label="所在省市区"
          placeholder="点击选择省市区"
          @click="showArea = true"
          required
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
            :area-list="areaList"
            @confirm="onConfirm"
            @cancel="showArea = false"
          />
        </van-popup>
        <van-field v-model="userInfo.address" label="邮寄地址" required />
        <van-field v-model="userInfo.email" label="邮箱" />
        <van-field v-model="userInfo.qq" label="qq号" type="number" />
        <van-field v-model="userInfo.wechat" label="微信号" />
        <van-field label="是否使用过丘比产品">
          <template #input>
            <van-radio-group
              v-model="userInfo.is_use_product"
              direction="horizontal"
              checked-color="#D33A46"
            >
              <van-radio :name="1">是</van-radio>
              <van-radio :name="2">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          readonly
          clickable
          name="picker"
          :value="productName"
          label="最喜欢的丘比产品"
          placeholder="点击选择"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="productNames"
            @confirm="onProductConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
        <div style="margin: 16px">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            color="#D33A46"
            :disabled="sendButtonAbled"
            >确认修改</van-button
          >
        </div>
        <div class="privacy" @click="privacyClick">隐私条款</div>
      </van-form>
    </div>
  </div>
</template>
<script>
import UserInfo from "./child/UserInfo";
import AttentItem from "./child/AttentItem";
import CollectItem from "./child/CollectItem";
import qs from "qs";
import {
  getAreaJson,
  getUserEdit,
  getUserUpload,
  getProducts,
  verification_codes,
} from "network/profile";

export default {
  name: "Attent",
  components: {
    UserInfo,
    AttentItem,
    CollectItem,
  },
  data() {
    return {
      userInfo: {},
      value: "", //文字省市区
      currentAreas: [],
      currentHeaderImg: String,
      showArea: false,
      areaList: {},
      currentIndex: 0,
      fileList: [],
      products: [], //产品列表
      productNames: [], //产品名字列表
      productName: "", //最喜欢的丘比产品
      showPicker: false, //选择产品
      sendButtonAbled: false, //提交按钮重复点击
      privacyShow: false, //隐私政策
      errorPhone: "", //手机号错误提示信息
      isChangePhone: false, //是否修改过手机号
      verification_code: "",
      verification_key: "",
      codeShow: true, //判断显示隐藏
      count: "获取验证码", //显示时的文字内容
      timer: null,
    };
  },
  computed: {},
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (this.userInfo.province && this.userInfo.city && this.userInfo.county) {
      this.value =
        this.userInfo.province +
        "-" +
        this.userInfo.city +
        "-" +
        this.userInfo.county;
    }

    getAreaJson().then((res) => {
      this.areaList = res;
    });
    getProducts().then((res) => {
      this.products = res.data;
      this.productNames = res.data.map((item) => {
        return item.name;
      });
      this.products.forEach((item) => {
        if (item.id === this.userInfo.favourite_product_id) {
          this.productName = item.name;
        }
      });
    });
  },
  mounted() {},
  methods: {
    itemClick(index) {
      if (this.currentIndex === index) {
        return;
      }
      this.currentIndex = index;
    },
    //发送验证码
    sendCodeClick() {
      const regMobile = /^1[3-9]\d{9}$/;
      if (regMobile.test(this.userInfo.phone)) {
      } else {
        this.$toast("手机号码格式错误");
        return;
      }
      console.log(11111111111111111111);

      //点击获取验证码
      const params = { phone: this.userInfo.phone };
      verification_codes(qs.stringify(params)).then((res) => {
        this.verification_key = res.data.key;
      });
      const TIME_COUNT = 60; //倒计时60秒
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    //手机号修改后出现验证码输入框
    changePhone() {
      this.isChangePhone = true;
    },
    //失去焦点
    phoneBlur() {
      const regMobile = /^1[3-9]\d{9}$/;
      if (regMobile.test(this.userInfo.phone)) {
        this.errorPhone = "";
      } else {
        this.errorPhone = "手机号码格式错误";
      }
    },
    //上传头像
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      var post = new FormData();
      post.append("cover_image", file.file);
      getUserUpload(post).then((res) => {
        if (res.error === 0) {
          this.currentHeaderImg = res.data.file_url;
        }
      });
    },
    //删除头像
    beforeDelete() {
      this.currentHeaderImg = "";
      return true;
    },
    //选择省市区
    onConfirm(values) {
      this.currentAreas = values;
      this.value = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("-");
      this.showArea = false;
    },
    //选择最喜欢的产品
    onProductConfirm(value) {
      this.productName = value;
      this.showPicker = false;
    },
    //提交
    onSubmit() {
      const regMobile = /^1[3-9]\d{9}$/;

      if (regMobile.test(this.userInfo.phone)) {
        this.errorPhone = "";
      } else {
        this.errorPhone = "手机号码格式错误";
        this.$toast("手机号码格式错误");
        return;
      }
      if (this.isChangePhone) {
        if (!this.verification_code) {
          this.$toast("请输入验证码");
          return;
        }
      }
      this.sendButtonAbled = true;
      if (this.currentAreas.length) {
        this.userInfo.province = this.currentAreas[0].name;
        this.userInfo.city = this.currentAreas[1].name;
        this.userInfo.county = this.currentAreas[2].name;
        this.userInfo.area_code =
          this.currentAreas && this.currentAreas[2].code;
      }
      if (this.currentHeaderImg.length) {
        this.userInfo.headimgurl = this.currentHeaderImg;
      }
      if (this.productName.length > 0) {
        let proIndex = 0;
        this.productNames.forEach((item, index) => {
          if (this.productName == item) {
            proIndex = index;
          }
        });

        this.userInfo.favourite_product_id = this.products[proIndex].id;
      }
      //修改手机号需要验证码
      if (this.isChangePhone) {
        this.userInfo.verification_code = this.verification_code;
        this.userInfo.verification_key = this.verification_key;
      }

      getUserEdit(this.userInfo.id, qs.stringify(this.userInfo))
        .then((res) => {
          this.sendButtonAbled = false;

          if (res.code) {
            this.$toast(res.message);
          } else {
            this.userInfo = res.data;
            localStorage.setItem("userInfo", JSON.stringify(this.userInfo));

            if (
              this.userInfo.province &&
              this.userInfo.city &&
              this.userInfo.county
            ) {
              this.value =
                this.userInfo.province +
                "-" +
                this.userInfo.city +
                "-" +
                this.userInfo.county;
            }
            this.$toast("修改成功");
            this.$router.push({
              path: '/profile',
            })
            // this.$router.go(-1);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //点击隐私政策
    privacyClick() {
      this.$router.push({
        path: "/privacy",
      });
    },
  },
};
</script>
<style scoped>
.edit {
  background: #f5f5f5;
  min-height: 100vh;
}
.content-bg {
  margin: 20px 15px 0px 15px;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
}
.content-bg h3 {
  font-size: 12px;
  font-weight: normal;
  padding-bottom: 10px;
  text-align: center;
  text-decoration: underline;
  color: var(--color-main);
}
.privacy {
  padding: 0px 10px;
  font-size: 13px;
  text-align: center;
  text-decoration: underline;
  color: var(--color-main);
}
</style>